import React from "react";
import { useFormContext } from "react-hook-form";
import { CircleLoader } from "@/components/ui/circleLoader";
import { Alert, AlertDescription } from "@/components/ui/alert";
import type { LoginFormInputs } from "./types";
import { Link } from "react-router";

interface LoginFormProps {
  isLoading: boolean;
  error: string | null;
}

export const LoginForm: React.FC<LoginFormProps> = ({ isLoading, error }) => {
  const { register } = useFormContext<LoginFormInputs>();

  return (
    <>
      {error && (
        <Alert variant="destructive">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      <div>
        <label htmlFor="username" className="block text-sm font-medium text-ui-paragraph-text">
          Username
        </label>
        <div className="mt-1">
          <input
            id="username"
            type="text"
            autoComplete="username"
            required
            {...register("username")}
            className="block w-full appearance-none rounded-md border border-input px-3 py-2 placeholder-muted shadow-sm focus:border-primary focus:outline-none focus:ring-primary sm:text-sm"
          />
        </div>
      </div>

      <div>
        <label htmlFor="password" className="block text-sm font-medium text-ui-paragraph-text">
          Password
        </label>
        <div className="mt-1">
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            required
            {...register("password")}
            className="block w-full appearance-none rounded-md border border-input px-3 py-2 placeholder-muted shadow-sm focus:border-primary focus:outline-none focus:ring-primary sm:text-sm"
          />
        </div>
      </div>

      <div>
        <button
          type="submit"
          disabled={isLoading}
          className="flex w-full justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow-sm hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {isLoading && <CircleLoader />}
          {isLoading ? "Signing in..." : "Sign in"}
        </button>
      </div>
      <div className="mt-3">
        <p className="text-center text-sm text-ui-paragraph-text">
          Do not remember your password?{" "}
          <Link to="/reset-password" className="font-medium text-primary hover:text-primary/80">
            Reset it here.
          </Link>
        </p>
      </div>
    </>
  );
};
